// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY. USE cf-component-icon/src/svgtoreact.sh TO MODIFY

import React from 'react';
import PropTypes from 'prop-types';

var Clipboard = function Clipboard(_ref) {
  var className = _ref.className,
      label = _ref.label;
  return React.createElement(
    'svg',
    {
      className: className,
      'aria-label': label,
      xmlns: 'http://www.w3.org/2000/svg',
      viewBox: '0 0 16 16'
    },
    React.createElement('path', { d: 'M13.073 2.045h-1.344v1.563H4.487V2.045h-1.56a.576.576 0 0 0-.574.574v11.359a.576.576 0 0 0 .574.574h10.146a.576.576 0 0 0 .574-.574V2.619a.576.576 0 0 0-.574-.574zm-5.045 9.884H4.891V10.8h3.137zm3.109-2.611H4.865V8.187h6.272zm0-2.612H4.865V5.575h6.272z' }),
    React.createElement('path', { d: 'M5.238 1.448h5.525V2.79H5.238z' })
  );
};

Clipboard.propTypes = {
  className: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired
};

export default Clipboard;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/component-icon/es/reactsvgs/Clipboard.js
// module id = 1019
// module chunks = 1